import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PlusIcon } from 'primereact/icons/plus';
import { LiliButton } from '@lili/lili-frontend-common';
import { IInvoiceRecipient } from '../../../InvoiceCreation/types/types';
import { TEXTS } from '../constants';
import { phoneTemplate } from './cell-tempates/client-phone-template';
import { emailTemplate } from './cell-tempates/client-email-template';
import { addressTemplate } from './cell-tempates/client-address-template';
import { nameTemplate } from './cell-tempates/client-name-template';
import Heading from '../../../../../generic-components/Heading';
import { ReactComponent as InvoiceIcon } from '../../../../../assets/icons/svg/stamp-icons/ic-stamp-invoice.svg';
import { featureAccess, LimitedFeatureType } from '../../../../../services/appAccess.service';
import { FeatureAccess } from '../../../../AccountSettings/components/rolesAndPermissions/PermissionsList';

interface IClientsTableProps {
  clients: IInvoiceRecipient[];
  onEditClick: (product: IInvoiceRecipient) => void;
  onDeleteClick: (product: IInvoiceRecipient) => void;
  onAddNewClick: () => void;
  showEmptyState: boolean;
}

export const ClientsTable = ({
  clients,
  onAddNewClick,
  showEmptyState,
  onEditClick,
  onDeleteClick,
}: IClientsTableProps) => {
  const { t } = useTranslation();
  const { NAME_COLUMN, EMAIL_COLUMN, PHONE_COLUMN, ADDRESS_COLUMN, EMPTY_STATE } = TEXTS.CLIENTS_HUB.CLIENTS_TABLE;
  const headerClassName = 'py-[10px] px-0 font-metricRSemibold text-[14px] text-bw07 text-left';
  const columnClassName = 'p-0';
  const [lastMenuRef, setLastMenuRef] = useState<any | null>(null);
  const invoicesPermission = featureAccess(null, LimitedFeatureType.Invoices);

  return (
    <div className='z-10 max-h-screen overflow-y-scroll border-[1px] rounded-[8px] border-bw03'>
      <DataTable
        id='data-table-prime-react-products'
        value={clients}
        selectionMode='single'
        onSelectionChange={() => {}}
        tableStyle={{ minWidth: '50rem' }}
        scrollable
        scrollHeight='70vh'
        className='p-0 m-0'
        emptyMessage={
          showEmptyState && (
            <div className='flex flex-col w-full items-center pt-[157px]'>
              <InvoiceIcon />
              <Heading
                title={t(EMPTY_STATE.TITLE)}
                className='mb-[24px] font-metricR text-[18px] text-bw08 mt-[18px]'
              />
              <LiliButton
                id='planPickerTab'
                title={t(EMPTY_STATE.ADD_BUTTON)}
                className='text-[14px] mb-[121px] w-[190px] h-[40px]'
                onClick={onAddNewClick}
                icon={<PlusIcon className='mr-[10px]' />}
              />
            </div>
          )
        }
      >
        <Column
          headerClassName={`${headerClassName} pl-[28px]`}
          className={`${columnClassName} w-[160px]`}
          field='name'
          header={t(NAME_COLUMN)}
          sortable
          sortField='name'
          body={nameTemplate}
        />
        <Column
          headerClassName={headerClassName}
          className={`${columnClassName} w-[200px]`}
          field='email'
          header={t(EMAIL_COLUMN)}
          body={emailTemplate}
        />
        <Column
          headerClassName={headerClassName}
          className='p-0 w-[90px]  '
          field='phone'
          header={t(PHONE_COLUMN)}
          body={phoneTemplate}
        />
        <Column
          headerClassName={headerClassName}
          className={`${columnClassName} w-[200px]`}
          field='address'
          header={t(ADDRESS_COLUMN)}
          body={(recipient) =>
            addressTemplate(
              recipient,
              (menuRef, event) => {
                lastMenuRef?.hide(event);
                menuRef.toggle(event);
                setLastMenuRef(menuRef);
              },
              () => {
                onEditClick(recipient);
              },
              () => {
                onDeleteClick(recipient);
              },
              invoicesPermission === FeatureAccess.READ_WRITE,
            )}
        />
      </DataTable>
    </div>
  );
};
